<template>
  <div :class="['textroller']" :style="{color: color, 'background-image': background}"></div>
</template>
<script>
import TextRoller from './textroller'
export default {
  data () {
    return {
      instance: null,
      color: 'red',
      background: 'radial-gradient(rgba(255, 0, 0, 0.4), #000000)',
    }
  },
  mounted () {
    const palavras = []
    for (let i = 0; i < 5; i++) {
      palavras.push(this.gerarPalavra())
    }
    this.instance = new TextRoller({
      el: this.$el,
      // value: 1000,
      values: ['000000'],
      // format: 'd',
      // animation: 'count',
      align: 'center',
      duration: 1000,
      // delay: 3000,
      loop: false,
    })
    const self = this
    const intervalo = setInterval(() => {
      var pal = self.gerarPalavra()
      self.instance.update(pal)
    }, 2500)
    setTimeout(() => {
      clearInterval(intervalo)
      setTimeout(() => {
        const ReqResp = self.$store.getters['raffle/ReqResp']
        var pal
        if (ReqResp.request && ReqResp.response.msg === 'success') {
          pal = ReqResp.response.ticket_id
          self.color = 'green'
          self.background = 'radial-gradient(rgba(139, 245, 165, 0.4), #000000)'
        } else {
          pal = ' ERRO '
        }
        self.instance.update(pal)
        self.$emit('terminou', true)
      }, 1500)
    }, 12000)
  },
  methods: {
    gerarPalavra () {
      var letras = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
      var pal = ''
      var letra = ''
      while (pal.length < 6) {
        letra = (Math.random() * letras.length).toFixed(0)
        if (letras[letra] !== undefined) {
          pal += letras[letra]
        }
      }
      return pal
    },
  },
}
</script>

<style>
/* stylelint-disable */
@import './odometer-theme-digital.css';

.textroller {
  font-size: 140px;
}

.vermelho-odm {
  background-image: -webkit-gradient(radial, 50% 50%, 0, 50% 50%, 100, color-stop(0%, rgba(255, 0, 0, 0.4)), color-stop(100%, #000000));
  background-image: -webkit-radial-gradient(rgba(255, 0, 0, 0.4), #000000);
  background-image: -moz-radial-gradient(rgba(255, 0, 0, 0.4), #000000);
  background-image: -o-radial-gradient(rgba(255, 0, 0, 0.4), #000000);
  background-image: -ms-radial-gradient(rgba(255, 0, 0, 0.4), #000000);
  background-image: radial-gradient(rgba(255, 0, 0, 0.4), #000000);
  background-color: black;
  font-family: "Wallpoet", monospace;
  padding: 0 0.2em;
  line-height: 1.1em;
  color: #ff0000;
}

.verde-odm {
  background-image: -webkit-gradient(radial, 50% 50%, 0, 50% 50%, 100, color-stop(0%, rgba(139, 245, 165, 0.4)), color-stop(100%, #000000));
  background-image: -webkit-radial-gradient(rgba(139, 245, 165, 0.4), #000000);
  background-image: -moz-radial-gradient(rgba(139, 245, 165, 0.4), #000000);
  background-image: -o-radial-gradient(rgba(139, 245, 165, 0.4), #000000);
  background-image: -ms-radial-gradient(rgba(139, 245, 165, 0.4), #000000);
  background-image: radial-gradient(rgba(139, 245, 165, 0.4), #000000);
  background-color: black;
  font-family: "Wallpoet", monospace;
  padding: 0 0.2em;
  line-height: 1.1em;
  color: #8bf5a5;
}
</style>
